// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".league-img__ellipse[data-v-7ff3a6f6]{filter:drop-shadow(0 3px 0 var(--color-league-purple-shadow))}.league-img__highlight[data-v-7ff3a6f6]{background:#fff;border-radius:50%;height:4.12%;left:45.44%;pointer-events:none;position:absolute;top:29.65%;width:9.62%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
